
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { confirmed } from 'vee-validate/dist/rules'
import { Component, Vue } from 'vue-property-decorator'
import { appName } from '@/env'
import mainModule from '@/store/main'

extend('confirmed', { ...confirmed, message: 'Passwords do not match' })

@Component({
  components: { ValidationObserver, ValidationProvider }
})
export default class UserProfileEdit extends Vue {
  public appName = appName
  public password1 = ''
  public password2 = ''

  public mounted(): void {
    this.checkToken()
  }

  public reset(): void {
    this.password1 = ''
    this.password2 = ''
  }

  public cancel(): void {
    this.$router.push({ name: 'root' })
  }

  public checkToken(): string | undefined {
    const token = this.$router.currentRoute.query.token as string
    if (!token) {
      mainModule.addNotification({
        content: 'No token provided in the URL, start a new password recovery',
        color: 'error'
      })
      this.$router.push({ name: 'auth-password-recovery' })
    } else {
      return token
    }
  }

  public async submit(): Promise<void> {
    const token = this.checkToken()
    if (token) {
      // await mainModule.actionResetPassword({
      //   token,
      //   password: this.password1
      // })
      this.$router.push({ name: 'root' })
    }
  }
}
